<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Cadastro de Cliente'">
          <template v-slot:preview>
            <v-form v-model="valid" ref="form">
              <v-container>
                <!-- <v-row>
                  <v-col
                    cols="6"
                    v-for="(arq, indexArq) in documento.arquivos"
                    :key="arq.idFront"
                  >
                    <input
                      type="file"
                      accept=".png, .jpeg, .bmp, .webp, .pdf"
                      class="mb-2"
                      required
                      @change="setFiles"
                      :data-indexarq="indexArq"
                    />
                    <v-btn
                      v-if="indexArq > 0"
                      color="error"
                      icon
                      @click="excluirArquivo(indexArq)"
                      class="ml-5"
                      ><v-icon small>fas fa-trash</v-icon></v-btn
                    >
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-img
                      v-if="previewUrl"
                      style="max-width: 500px; max-height: 300px; width: 100%"
                      :src="previewUrl"
                    ></v-img>
                    <v-file-input v-if="cliente.id === 0"
                      type="file"
                      label="Logotipo"
                      accept="image/png, image/jpg, image/jpeg, image/bmp, image/webp, pdf"
                      class="mb-2"
                      required
                      :rules="[rules.required]"
                      @change="handleFilePreview"
                      v-model="logoFile"
                    >
                    </v-file-input>
                    <v-file-input v-else
                      type="file"
                      label="Logotipo"
                      accept="image/png, image/jpg, image/jpeg, image/bmp, image/webp, pdf"
                      class="mb-2"
                      required
                      @change="handleFilePreview"
                      v-model="logoFile"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model.trim="cliente.nome"
                      label="Nome"
                      clearable
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="cliente.cpfcnpj"
                      label="CPF/CNPJ"
                      clearable
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      :disabled="cliente.id != 0"
                      v-model="cliente.tagUrl"
                      label="TagUrl"
                      clearable
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="representantes"
                      label="Representante"
                      item-text="nome"
                      item-value="id"
                      v-model="cliente.representanteID"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-btn @click="salvar" color="primary" :disabled="saving"
                  >Salvar</v-btn
                >
              </v-container>
            </v-form>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <TelaLoading :overlay="saving"></TelaLoading>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";

export default {
  name: "clienteCadastro",
  data() {
    return {
      valid: false,
      saving: false,
      cliente: {
        id: 0,
        representanteID: 0,
        nome: "",
        cpfcnpj: "",
      },
      representantes: [],
      logoFile: null,
      previewUrl: null,
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
    };
  },
  components: {
    KTCodePreview,
    TelaLoading,
  },
  methods: {
    listarRepresentantes() {
      return new Promise((resolve) => {
        ApiService.get("representante").then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.representantes = data.data;
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    async salvar() {
      if (this.$refs.form.validate()) {
        let self = this;

        if (this.cliente.id === 0 && !this.logoFile) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Selecione um Logo",
            showConfirmButton: false,
            timer: 1500,
          }).then(function () {
            self.$router.push({ name: "cliente" });
          });
        }

        const formData = new FormData();
        formData.append("logoFile", this.logoFile);
        formData.set("clienteJson", JSON.stringify(this.cliente));

        try {
          this.saving = true;

          const { data: result } =
            this.cliente.id === 0
              ? await ApiService.post("cliente/incluir", formData)
              : await ApiService.put(
                  "cliente/alterar/" + this.cliente.id,
                  formData
                );

          if (!result.success) {
            Swal.fire({
              position: "center",
              icon: "error",
              title:
                this.cliente.id === 0
                  ? "Não foi possivel cadastrar o cliente!"
                  : "Não foi possivel alterar o cliente!",
              showConfirmButton: false,
              timer: 1500,
            });
            this.saving = false;
            return;
          }

          Swal.fire({
            position: "center",
            icon: "success",
            title:
              this.cliente.id === 0
                ? "Cliente Cadastrado com Sucesso!"
                : "Cliente alterado com Sucesso!",
            showConfirmButton: false,
            timer: 1500,
          }).then(function () {
            self.$router.push({ name: "cliente" });
          });
        } catch (error) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Ocorreu um erro insperado",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        this.saving = false;
      }
    },

    buscarCliente(id) {
      return new Promise((resolve) => {
        ApiService.get("cliente/" + id).then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.cliente = data.data;
            this.previewUrl = data.data.caminhoVisualizacao;
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    handleFilePreview() {
      this.previewUrl =
        this.logoFile != null ? URL.createObjectURL(this.logoFile) : null;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Clientes" }]);

    this.listarRepresentantes();

    if (this.$route.params.id !== undefined)
      this.buscarCliente(this.$route.params.id);
  },
};
</script>
